module.exports = {
    "source_code": "HLXEMS",
    "site_id": "explore.carlow.edu",
    "title": "Carlow University",
    "tfn": "",
    "url": "https://explore.carlow.edu/",
    "gtm_code": "GTM-K2LC3DPB",
}